import { useMemo } from "react";

import { ResourceKind } from "../../gql-generated/types";
import { useOrgChildResources } from "../../shared/hooks/useOrgChildResources";
import { type ApolloResult, type KeyedOption } from "../../shared/models";

import { makeLensSpaceOptions } from "./makeLensSpaceOptions";

export const useLensSpaceOptionsV2 = (): ApolloResult<{ options: KeyedOption[] }> => {
    const {
        resourceContainers: lensSpaces,
        loading,
        error,
    } = useOrgChildResources({
        kind: ResourceKind.LensSpaces,
        limit: 0,
    });

    const options = useMemo(() => makeLensSpaceOptions(lensSpaces), [lensSpaces]);

    return { options, loading, error };
};
